import axios from 'axios'
import { Message } from 'element-ui';
import router from '../../../router/index'
import util from '../util/util'
import config from '../config'
import Vue from 'vue'

// 创建一个 axios 实例
const service = axios.create({
    withCredentials: true,
    baseURL: config.baseUrl + '/api/',
    timeout: 3600000 // 请求超时时间
})

// 请求拦截器
service.interceptors.request.use(
    config => {
        if(config.needAdmin !== false){
            config.url = 'school/' + config.url
        }
        config.method = config.method ? config.method : 'POST'

        if(config.method.toUpperCase() == 'GET'){
            let params = [], data = config.data
            for(var i in data){
                params.push(i +'=' + data[i])
            }
            if(params.length > 0){
                config.url += '?' + params.join('&')
            }
        }

        let authToken = util.cacheGet("authTokenSchool");
        if(authToken) {
            config.headers['Authorization'] = authToken;
        }
        return config
    },
    error => {
        // 发送失败
        // console.log(error)
        return Promise.reject(error)
    }
)

// 响应拦截器
service.interceptors.response.use(
    response => {

        if(response.data.status == 0){

            if(response.data.code == 'A0230'){
                // 需要登录了！
                util.cacheSet("authTokenSchool", null);
                util.cacheSet('admin_login_messgae', '请先登录！');
                if(window.location.href.indexOf('/login') == -1){
                    router.push({
                        name: 'Login',
                    })
                }
            }else{
                 Message({
                    message: response.data.msg,
                    type: 'error'
                });
            }
        }
        return response.data
    },
    error => {
        Message({
        	message: '系统错误！请联系管理员',
        	type: 'error'
        });
        if (error && error.response) {
            console.log(error.response)
        }
        return Promise.reject(error)
    }
)

export default service



// WEBPACK FOOTER //
// ./src/assets/js/api/index.js